import { render } from "./loginRecuiter.vue?vue&type=template&id=7fb4791d&scoped=true"
import script from "./loginRecuiter.vue?vue&type=script&lang=js"
export * from "./loginRecuiter.vue?vue&type=script&lang=js"

import "./loginRecuiter.vue?vue&type=style&index=0&id=7fb4791d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fb4791d"

export default script